import { ApiResult, HttpClient } from "../http.js";
import { KsItemType, KsTemplateDto, KsTradeType } from "../types/ks-templates.js";

export interface KsTemplateItemPayload {
  id: string;
  title: string;
  description?: string | null;
  type: KsItemType;
  isBlocker: boolean;
  required: boolean;
  order: number;
  category?: string | null;
  helpText?: string | null;
  options?: string[] | null;
}

export interface CreateKsTemplatePayload {
  name: string;
  description?: string | null;
  tradeType?: KsTradeType | null;
  isActive: boolean;
  items?: KsTemplateItemPayload[] | null;
  id?: string;
}

export interface UpdateKsTemplatePayload {
  name: string;
  description?: string | null;
  tradeType?: KsTradeType | null;
  isActive: boolean;
  items?: KsTemplateItemPayload[] | null;
}

export interface ListKsTemplatesQuery {
  isActive?: boolean;
}

export class KsTemplatesApi {
  constructor(private readonly http: HttpClient) {}

  list(query: ListKsTemplatesQuery = {}): Promise<ApiResult<KsTemplateDto[]>> {
    return this.http.get<KsTemplateDto[]>("/api/ks-templates", { query: { ...query } });
  }

  get(id: string): Promise<ApiResult<KsTemplateDto>> {
    return this.http.get<KsTemplateDto>(`/api/ks-templates/${encodeURIComponent(id)}`);
  }

  create(payload: CreateKsTemplatePayload): Promise<ApiResult<string>> {
    return this.http.post<string>("/api/ks-templates", { body: payload });
  }

  update(id: string, payload: UpdateKsTemplatePayload): Promise<ApiResult<KsTemplateDto>> {
    return this.http.put<KsTemplateDto>(`/api/ks-templates/${encodeURIComponent(id)}`, { body: payload });
  }

  remove(id: string): Promise<ApiResult<string>> {
    return this.http.delete<string>(`/api/ks-templates/${encodeURIComponent(id)}`);
  }
}
